import React from 'react';
import { useParams } from 'react-router-dom';
import StreamTimerWidget from './StreamTimerWidget';
import KanbanOverlayWidget from './KanbanOverlayWidget';
import RotatingStatsPanel from './RotatingStatsPanel';
import ChatUserCircles from './ChatUserCircles';
import SummerOverlayDecorations from './SummerOverlayDecorations';
import useTwitchChat from '../hooks/useTwitchChat';
import useTwitchStatus from '../hooks/useTwitchStatus';
import useWidgetConfig from '../hooks/useWidgetConfig';
import { summerOverlayStyles } from '../overlayThemes/summerOverlayStyles';
import { SUMMER_STAR_COLORS, mergeSummerConfig } from '../overlayThemes/summerConstants';

export default function StreamOverlayNoCameraSummer() {
  const { channelName } = useParams();
  const normalizedChannel = channelName?.toLowerCase().trim() || 'itsflannelbeard';
  const { activeUsers, monitorBotUsername } = useTwitchChat(normalizedChannel);
  const { config, getEnabledWidgets } = useWidgetConfig(normalizedChannel);
  const { isLive } = useTwitchStatus(normalizedChannel);
  const RIGHT_OVERLAY_RESERVED_WIDTH = 667;
  const summerConfig = mergeSummerConfig(config);

  const WIDGET_CSS_CLASS = { timer: 'widget-timer', kanban: 'widget-kanban', rotatingStats: 'widget-rotating' };

  const renderWidget = (key) => {
    switch (key) {
      case 'timer':
        return <StreamTimerWidget compact={true} flannelStyle={true} active={isLive} />;
      case 'kanban':
        return <KanbanOverlayWidget compact={true} flannelStyle={true} active={isLive} />;
      case 'rotatingStats':
        return (
          <RotatingStatsPanel
            channelName={normalizedChannel}
            config={summerConfig}
            active={isLive}
          />
        );
      default:
        return null;
    }
  };

  const enabledWidgets = getEnabledWidgets();

  return (
    <div className="summer-overlay-container">
      <SummerOverlayDecorations />

      <div className="summer-bottom-panel">
        <div className="summer-stitch-top" />
        <div className="widget-row">
          {enabledWidgets.map(w => (
            <div key={w.key} className={`summer-widget ${WIDGET_CSS_CLASS[w.key] || ''}`}>
              {renderWidget(w.key)}
            </div>
          ))}
        </div>
      </div>

      <div className="overlay-chat overlay-chat--bottom">
        <div className="chat-pixel-border">
          <div className="chat-window">
            <div className="chat-dock-area" />
          </div>
        </div>
      </div>

      <ChatUserCircles
        users={activeUsers}
        channelName={normalizedChannel}
        monitorBotUsername={monitorBotUsername}
        reservedRightWidth={RIGHT_OVERLAY_RESERVED_WIDTH}
        starColors={SUMMER_STAR_COLORS}
        usernameColor="#fff8e7"
        usernameTextShadow="1px 1px 0 #0077b6"
      />

      <style>{summerOverlayStyles}</style>
    </div>
  );
}
